module.exports = __webpack_public_path__ + "static/media/KUSD.d9437a5a.png";